import * as React from 'react';
import { Component } from 'react';
import { observer } from 'mobx-react';
import { withTheme } from 'styled-components';
import { styled } from '../utils/styled';
import { propStyles } from '../utils/propStyles';
import Translate from './Translate';
import { Theme } from '../models/Theme';

const RiskLevelsWrapper = styled<any, any>('div', 'riskLevelsWrapper', 'srri')`
    ${propStyles};
`;

const RiskLevels = styled<any, any>('ol', 'riskLevels', 'srri')`
    ${propStyles};
    list-style: none;
`;

RiskLevels.defaultProps = {
    flex: '1 0 100%',
    alignSelf: 'stretch',
    margin: '0 0 0.5em 0',
    display: 'flex',
    fontSize: 'xs',
};

const RiskLevel = styled<any, any>('li', 'riskLevel', 'srri')`
    ${propStyles};
`;

RiskLevel.defaultProps = {
    flex: '1 0 auto',
    textAlign: 'center',
    color: 'gray500',
    bgColor: 'white',
    borderWidth: '1px',
    borderColor: 'gray500',
    borderStyle: 'solid',
    margin: '0 0 0 -1px',
    paddingY: '0.25em',
    selected: {
        position: 'relative',
        color: 'white',
        bgColor: 'primary',
        borderColor: 'primary',
    },
};

const RiskLabels = styled<any, any>('div', 'riskLabels', 'srri')`
    ${propStyles};
`;

RiskLabels.defaultProps = {
    display: 'flex',
    flex: '1 1 auto',
    justifyContent: 'space-between',
    alignItems: 'center',
    alignSelf: 'stretch',
};

const RiskLabel = styled<any, any>('p', 'riskLabel', 'srri')`
    ${propStyles};
`;

RiskLabel.defaultProps = {
    color: 'gray500',
    fontSize: '11px',
};

interface SRRIProps {
    theme?: Theme;
    higherRiskLabel?: string;
    lowerRiskLabel?: string;
    rating: number;
}
@observer
class SRRI extends Component<SRRIProps> {
    render() {
        const {
            theme,
            higherRiskLabel = 'Higher Risk',
            lowerRiskLabel = 'Lower Risk',
            rating = 0,
        } = this.props;
        const ratingArr = Array.from(Array(7).keys());

        return (
            <RiskLevelsWrapper role={'text'} aria-label={`${rating}`}>
                <RiskLevels {...theme.SRRIRiskLevels} aria-hidden={true}>
                    {ratingArr.map((r, i) => (
                        <RiskLevel
                            key={i}
                            data-selected={i === rating - 1}
                            {...theme.SRRIRiskLevel}
                        >
                            {i + 1}
                        </RiskLevel>
                    ))}
                </RiskLevels>
                <RiskLabels {...theme.SRRIRiskLabels} aria-hidden={true}>
                    <RiskLabel
                        textAlign="left"
                        margin="0 1em 0 0"
                        {...theme.SRRIRiskLabel}
                        {...theme.SRRILowerRiskLabel}
                    >
                        <Translate>{lowerRiskLabel}</Translate>
                    </RiskLabel>
                    <RiskLabel
                        textAlign="right"
                        margin="0 0 0 1em"
                        {...theme.SRRIRiskLabel}
                        {...theme.SRRIHigherRiskLabel}
                    >
                        <Translate>{higherRiskLabel}</Translate>
                    </RiskLabel>
                </RiskLabels>
            </RiskLevelsWrapper>
        );
    }
}

export default withTheme(SRRI);



// WEBPACK FOOTER //
// ./src/Components/SRRI.tsx